import React from 'react';
import { CloseIcon } from './Icons';

export function ModalHeader({ title, onClose, children }) {
  return (
    <div className="ci-modal-header">
      <h2>{title}</h2>
      <div className="ci-modal-header-actions">
        {children}
        <button className="ci-modal-close-btn" type="button" onClick={onClose} aria-label="Close">
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}
